import { Org } from '@Interfaces/Data/OrganizationInterface'

export const isBusinessOrganization = (org: Org | null | undefined): boolean =>
  org?.type === 'business'

/**
 * Check if organization type string is nonprofit or community
 * Pure utility function - can be used with just the type string
 */
export const isNonprofitOrCommunityType = (orgType: string | undefined | null): boolean => {
  return orgType === 'nonprofit' || orgType === 'community'
}

/**
 * Check if organization is nonprofit or community type
 * Accepts full Org object for convenience
 */
export const isNonprofitOrCommunity = (org: Org | null | undefined): boolean => {
  return isNonprofitOrCommunityType(org?.type)
}

/**
 * Get organization type category: 'nonprofit' | 'business'
 * Returns null if org type cannot be determined
 */
export const getOrgTypeCategory = (org: Org | null | undefined): 'nonprofit' | 'business' | null => {
  if (!org?.type) return null
  if (isNonprofitOrCommunityType(org.type)) return 'nonprofit'
  return 'business'
}
